'use client';

import React from 'react';
import dynamic from 'next/dynamic';
import { ChartSkeleton } from '@/components/ui/LoadingSkeleton';

const LeaveTypeChart = dynamic(() => import('./LeaveTypeChart'), {
  ssr: false,
  loading: () => <ChartSkeleton height={260} />,
});

const ExpenseTypeChart = dynamic(() => import('./ExpenseTypeChart'), {
  ssr: false,
  loading: () => <ChartSkeleton height={260} />,
});

export default function DashboardCharts() {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2 gap-4">
      <div className="bg-card border border-border rounded-xl p-5 shadow-card">
        <div className="mb-4">
          <h2 className="text-sm font-600 text-foreground">Leave Requests by Type</h2>
          <p className="text-xs text-muted-foreground mt-0.5">Distribution across all departments</p>
        </div>
        <LeaveTypeChart />
      </div>
      <div className="bg-card border border-border rounded-xl p-5 shadow-card">
        <div className="mb-4">
          <h2 className="text-sm font-600 text-foreground">Fund Requests by Expense Type</h2>
          <p className="text-xs text-muted-foreground mt-0.5">Request count by category this cycle</p>
        </div>
        <ExpenseTypeChart />
      </div>
    </div>
  );
}